import React from 'react';
import PropTypes from 'prop-types';
import noop from 'lodash/noop';
import { ProfileSettingsConfig } from '@Constants/rx-user/constants';
import { Checkbox } from '@els/els-react--checkbox';
import ProfileSettingsAccordionItem from '@Pages/ProfileSettings/Components/ProfileSettingsAccordionItem';

import './ShowAutoplan.scss';

function ShowAutoplan({ currentOption, onChange, onSave, onClose, onReset }) {
  return (
    <ProfileSettingsAccordionItem
      onClose={onClose}
      onSave={onSave}
      label={ProfileSettingsConfig.Labels.showSynthesisPlannerParameters}
      title={currentOption ? ProfileSettingsConfig.Labels.alwaysShowScreenBeforeCreatingAutoplan : ''}
      value={currentOption && ProfileSettingsConfig.Labels.alwaysShowScreenBeforeCreatingAutoplan}
      resetButton
      titled
      validateOnSave
      onReset={onReset}
      className="show-autoplan-accordion-item preferences-accordion-item">
      <div className="preferences-accordion-item__wrapper">
        <div id="show-autoplan-checkbox-option" className="preferences-accordion-item__option">
          <div className="preferences-accordion-item__option_label">
            {ProfileSettingsConfig.Labels.alwaysShowScreenBeforeCreatingAutoplan}
          </div>
          <div className="preferences-accordion-item__checkbox_Wraper">
            <Checkbox
              data-e2e="preferences-show-autoplan-checkbox"
              name="RX2_SHOW_AUTOPLAN_PREF"
              onChange={(event) => onChange('RX2_SHOW_AUTOPLAN_PREF', event?.currentTarget?.checked)}
              checked={!!currentOption}
              id="RX2_SHOW_AUTOPLAN_PREF"
              className="preferences-accordion-item__checkbox"
              ariaControlsGuidance={ProfileSettingsConfig.Labels.alwaysShowScreenBeforeCreatingAutoplan}
            />
          </div>
        </div>
      </div>
    </ProfileSettingsAccordionItem>
  );
}

ShowAutoplan.propTypes = {
  currentOption: PropTypes.bool,
  onChange: PropTypes.func,
  onSave: PropTypes.func,
  onClose: PropTypes.func,
  onReset: PropTypes.func,
};

ShowAutoplan.defaultProps = {
  onChange: noop,
  onSave: noop,
  onClose: noop,
  onReset: noop,
};

export default ShowAutoplan;
